import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class DireccionService {
  constructor(private gqlclient: GraphQLClient) { }

  GetByCliente(
    inputParams: {
      empresa_rut: number;
      cliente_proveedor_rut: number;
    },
    callback: Function
  ) {
    // const inputParams = this.createInputParamsGetByCliente(inputData)
    this.executeQueryObtenerSegunFiltro(inputParams, callback);
  }

  GetDireccionCliente(
    inputParams: {
      cliente_proveedor_rut: number;
      codigo: number;
      empresa_rut: number;
    },
    callback: Function
  ) {
    // const inputParams = this.createInputParamsGetByCliente(inputData)
    this.ObtenerNombreDireccion(inputParams, callback);
  }

  // // FV: Lo hago a modo de limpiar la data de parámetros innecesarios y para direccionar la query en pro del contexto
  // private createInputParamsGetByCliente({ empresa_rut, cliente_proveedor_rut }) {
  //   return {
  //     empresa_rut,
  //     cliente_proveedor_rut
  //   }
  // }

  private executeQueryObtenerSegunFiltro(inputParams: any, callback: Function) {
    delete inputParams.sucursal_codigo;
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $cliente_proveedor_rut: Decimal) {
            direccion {
              obtenerSegunFiltro(filtro: { exacto: { empresa_rut: $empresa_rut, cliente_proveedor_rut: $cliente_proveedor_rut, direccion_completa: "", nombre: "", activo: true } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    nombre
                    codigo
                    direccion_completa
                    nombreRegion
                    nombreProvincia
                    nombreComuna
                    es_principal
                    facturar_a_casa_matriz
                    condicion_pago_codigo
                    usa_direccion_despacho
                    fono_movil
                    fono_fijo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta } = response.data.direccion.obtenerSegunFiltro;
        if (!respuesta) {
          callback(null);
          return;
        }

        const { registros } = respuesta;
        callback({ registros });
      }
    );
  }

  private ObtenerNombreDireccion(inputParams: any, callback: Function) {
    delete inputParams.sucursal_codigo;
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $cliente_proveedor_rut: Decimal, $codigo: Decimal) {
            direccion {
              obtenerSegunFiltroDireccionCliente(filtro: { exacto: { empresa_rut: $empresa_rut, cliente_proveedor_rut: $cliente_proveedor_rut, codigo: $codigo, activo: true } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    nombre
                    codigo
                    direccion_completa
                    nombreRegion
                    nombreProvincia
                    nombreComuna
                    es_principal
                    facturar_a_casa_matriz
                    condicion_pago_codigo
                    usa_direccion_despacho
                    fono_movil
                    fono_fijo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta } = response.data.direccion.obtenerSegunFiltroDireccionCliente;
        if (!respuesta) {
          callback(null);
          return;
        }

        const { registros } = respuesta;
        callback({ registros });
      }
    );
  }

  obtenerSegunDireccion(inputParams: any, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal, $direccionCodigo: Decimal) {
            direccion {
              obtenerCondicionPagPorDireccion(rutEmpresa: $rutEmpresa, rutCliente: $rutCliente, direccionCodigo: $direccionCodigo) {
                respuesta {
                  condicion_pago_codigo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta } = response.data.direccion.obtenerCondicionPagPorDireccion;
        if (!respuesta) {
          callback(null);
          return;
        }

        const { registros } = respuesta;
        callback({ registros });
      }
    );
  }
}
